import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const gibsontonConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Gibsonton Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Gibsonton, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_gibsonton',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Gibsonton',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Gibsonton Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring dependable tree care to the 
     waterfront and residential properties of <strong>Gibsonton</strong>. Sitting 
     along the Alafia River and Tampa Bay, this community deals with the combined 
     pressure of tidal flooding, storm surge, and river level wind exposure that 
     stresses trees and accelerates structural damage. When those trees start 
     leaning toward homes or blocking access, our team moves fast.`,

    `We specialize in <strong>hazardous tree removal in waterfront and flood prone 
     areas</strong> trees with root damage from repeated flooding, storm damaged 
     limbs near homes and boat docks, overgrown canopies in tight residential 
     settings, and post storm debris cleanup that restores access and safety 
     quickly. We bring the right equipment for wet site conditions.`,

    `<strong>Sam's Tree Service</strong> provides expert, affordable tree care 
     throughout <strong>Gibsonton</strong> and the surrounding 
     <strong>South Hillsborough</strong> waterfront communities keeping 
     your property safe and accessible all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Gibsonton, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Gibsonton = () => <LocationPage config={gibsontonConfig} />;
export default Services_Gibsonton;
